import axios from "axios";
import Http from "./http.init";
import { ResponseWrapper, ErrorWrapper } from "./util";
import $store from "../store";
import $router from "../router";
import { CONFIG } from "../config";

/**
 ******************************
 * @API
 ******************************
 */

export function makeLogin({ email, password }) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${CONFIG.API_URL}/auth/login`, { email, password })
      .then((response) => {
        _setAuthData(response);
        return resolve(new ResponseWrapper(response, response.data));
      })
      .catch((error) => reject(new ErrorWrapper(error)));
  });
}

export function makeLoginByToken(token) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${CONFIG.API_URL}/auth/token-login`, { token })
      .then((response) => {
        _setAuthData(response);
        return resolve(new ResponseWrapper(response, response.data));
      })
      .catch((error) => reject(new ErrorWrapper(error)));
  });
}

export function sendResetEmail({ email }) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${CONFIG.API_URL}/auth/password/email`, { email })
      .then((response) => {
        return resolve(new ResponseWrapper(response, response.data));
      })
      .catch((error) => reject(new ErrorWrapper(error)));
  });
}

export function sendResetEmailAuth(payload) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${CONFIG.API_URL}/users/profile`, payload)
      .then((response) => {
        return resolve(new ResponseWrapper(response, response.data));
      })
      .catch((error) => reject(new ErrorWrapper(error)));
  });
}

export function register(user) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${CONFIG.API_URL}/users`, { user })
      .then((response) => {
        return resolve(new ResponseWrapper(response, response.data));
      })
      .catch((error) => reject(new ErrorWrapper(error)));
  });
}

export function makeLogout() {
  return new Promise((resolve, reject) => {
    new Http({ auth: true })
      .post(`auth/logout`)
      .then((response) => {
        _resetAuthData();
        // $router.push({ name: 'index' })
        return resolve(new ResponseWrapper(response, response.data));
      })
      .catch((error) => reject(new ErrorWrapper(error)));
  });
}

export function resetPassword(object) {
  return new Promise((resolve, reject) => {
    // new Http({ auth: false }).post(`auth/password/reset`, object)
    const data = {
      token: object.token,
      email: object.email,
      password: object.password,
      password_confirmation: object.password_confirmation,
    };
    axios
      .post(`${CONFIG.API_URL}/auth/password/reset`, data)
      .then((response) => {
        return resolve(response);
      })
      .catch((error) => {
        const message = error.response.data
          ? error.response.data.error
          : error.response.statusText;
        reject(new ErrorWrapper(error, message));
      });
  });
}

export function resetPassword2(object) {
  return new Promise((resolve, reject) => {
    // new Http({ auth: false }).post(`auth/password/reset`, object)
    const data = {
      token: object.token,
      email: object.email,
      password: object.password,
      password_confirmation: object.password_confirmation,
      last_password: object.last_password,
    };
    return axios
      .patch(`${CONFIG.API_URL}/users/profile/password`, data)
      .then((response) => {
        return resolve(response);
      })
      .catch((error) => {
        const message = error.response.data
          ? error.response.data.error
          : error.response.statusText;
        reject(new ErrorWrapper(error, message));
      });
  });
}

export function checkRemeberToken(token, email) {
  return new Promise((resolve, reject) => {
    new Http({ auth: false })
      .post(`auth/p/reset/check`, { token, email })
      .then((response) => {
        return resolve(new ResponseWrapper(response, response.data));
      })
      .catch((error) => reject(new ErrorWrapper(error)));
  });
}

export function socialLogin(authResponse, profile, provider) {
  return new Promise((resolve, reject) => {
    new Http({ auth: false })
      .post(`oauth/${provider}/callback`, { authResponse, profile })
      .then((response) => {
        return resolve(new ResponseWrapper(response, response.data));
      })
      .catch((error) => reject(new ErrorWrapper(error)));
  });
}

export function refreshTokens() {
  return new Promise((resolve, reject) => {
    axios
      .post(`${CONFIG.API_URL}/auth/refresh`, {})
      .then((response) => {
        _setAuthData(response);
        return resolve(new ResponseWrapper(response, response.data));
      })
      .catch((error) => {
        if (error.response.status === 401) {
          _resetAuthData();
          $router.push({ name: "index" });
          return reject(new ErrorWrapper(error));
        }

        return reject(new ErrorWrapper(error));
      });
  });
}

/**
 ******************************
 * @methods
 ******************************
 */
export function isAccessTokenExpired() {
  const accessTokenExpDate = $store.state.auth.accessTokenExpDate - 1;
  const nowTime = Math.floor(new Date().getTime() / 1000);

  return accessTokenExpDate <= nowTime;
}

export function getRefreshToken() {
  return localStorage.getItem("refreshToken");
}

export function getAccessToken() {
  return localStorage.getItem("accessToken");
}

function _resetAuthData() {
  // reset userData in store
  $store.commit("user/SET_CURRENT_USER", {});
  $store.commit("auth/SET_ATOKEN_EXP_DATE", null);
  // reset tokens in localStorage
  localStorage.setItem("refreshToken", "");
  localStorage.setItem("accessToken", "");
}

function _setAuthData(response) {
  //  localStorage.setItem('refreshToken', response.data.token)
  localStorage.setItem("accessToken", response.data.token);
  $store.commit("SET_TOKEN_EXPIRATION", response.data.expires_in);
  $store.dispatch("saveToken", {
    token: response.data.token,
  });
  // $store.commit('auth/SET_ATOKEN_EXP_DATE', response.data.expires_in)
}
